import { LiveLikeOption } from "@livelike/engagementsdk";
const html = (window as any).html;

class SBSImagePredictionOption extends LiveLikeOption {
  @((window as any).property({ type: Function }))
  setOptionSelected: (arg: {}) => void = () => {};
  createRenderRoot(): this {
    return this;
  }
  optionSelected = () => {
    if (!this.disabled) {
      this.parentElement
        .querySelectorAll("sbs-image-prediction-option")
        .forEach((el: any) => {
          el !== this && (el.selected = false);
        });
      this.selected = true;
      this.setOptionSelected(this.item);
    }
  };

  votePercentage = () => {
    const items: any[] = (this as any).items || [];
    const totalVotes = items.reduce(
      (a: number, b: any) => a + (b?.vote_count || 0),
      0
    );
    const myVotes = (this as any).item?.vote_count || 0;
    return totalVotes > 0 ? Math.round((myVotes / totalVotes) * 100) : 0;
  };

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("click", this.optionSelected);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.optionSelected);
    super.disconnectedCallback();
  }

  render() {
    const pct = this.votePercentage();
    this.style.setProperty("--vote-pct", `${pct}%`);
    return html`
      <div class="sbs-option-fill"></div>
      <livelike-image height="60px"></livelike-image>
    `;
  }
}
customElements.define(
  "sbs-image-prediction-option",
  SBSImagePredictionOption as any
);
